export default "__VITE_ASSET__C1y9L4bc__"